import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <Link to="/" className="logo-wrapper">
          <img
            className="footer-logo"
            src="/images/LogoBlack.webp"
            alt="bitsAndBoltsLogo"
          />
          <div className="logo-name-wrapper">
            <div className="logo-name-line-1 black">BITS & BOLTS</div>
            <div className="logo-name-line-2 black">FROM IDEA TO LAUNCH</div>
          </div>
        </Link>

        <div className="footer-text-wrapper">
          <div className="footer-text">
            &copy; {new Date().getFullYear()} Bits & Bolts
          </div>
          <div className="footer-text">
            All rights reserved
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
